// @charset "utf-8";
const ua = 'pc'
export default {
    // 私募之家 个人中心
    personalCenter: {
        visit: { section: `personalcenter`, event: 'ready' }, // 访问个人中心
        addAccount: { section: `personalcenter`, act: 'tjmnzh' }, // 点击模拟账户申请内的添加账户
        submitAccount: { section: `personalcenter`, act: 'scmnzh' }, // 点击添加账户内的生成
        downloadFile: { section: `personalcenter`, act: 'jkwdxz' }, // 点击接口文档下载
        openWechat: { section: `personalcenter`, act: 'gfwx', event: ua === 'pc' ? 'mouseenter' : '' }, // 打开官方微信
        openPresale: { section: `personalcenter`, act: 'sxzx' }, // 打开售前咨询
        submitPresale: { section: `personalcenter`, act: 'tjsxzx' } // 提交售前咨询
    }
}



// WEBPACK FOOTER //
// ./src/lib/buriedPoint.js